



















































































































import { Component, Vue } from 'vue-property-decorator';

import { userStore } from '@/store/store';
import PxTextEntryBox from '@/views/components/input/formFields/PxTextEntryBox.vue';
import { User } from '@/interfaces/user';
import { email, minLength, required, sameAs } from 'vuelidate/lib/validators';
import ErrorDisplay from '@/views/components/projects/ErrorDisplay.vue';
import { states } from '@/lib/data/states';
import { countries } from '@/lib/data/countries';
import PxDropdown from '@/views/components/input/formFields/PxDropdown.vue';


Component.registerHooks(['validations']);

@Component({
  components: { PxDropdown, ErrorDisplay, PxTextEntryBox },
})
export default class CreateUser extends Vue {
  newUser: User = {
    id: null,
    first_name: null,
    last_name: null,
    email: null,
    country: null,
    state: null,
    date_joined: new Date(Date.now()).toISOString(),
    last_login: null,
    password: null,

    organization_name: null,
    organization_type: null,
    primary_field: null,
    title: null,
    experience: null,


    // is_superuser: boolean,
    // is_staff: boolean,
    // is_active: boolean,

    // Legacy,
    // organizationName?: string | null,
  };

  stateOptions = states;

  countryOptions = countries;

  password = '';

  password2 = '';

  tosAccepted = false;

  roleOptions = [
    { value: '', text: '-- Select One --' },
    { value: 'Structural', text: 'Structural' },
    { value: 'Pavement', text: 'Pavement' },
    { value: 'Geotechnical', text: 'Geotechnical' },
    { value: 'Planning', text: 'Planning' },
    { value: 'Management', text: 'Management' },
    { value: 'Other', text: 'Other' },
  ];

  orgTypeOptions = [
    { value: '', text: '-- Select One --' },
    { value: 'Public Agency', text: 'Public Agency' },
    { value: 'Private Owner', text: 'Private Owner' },
    { value: 'Engineering Firm', text: 'Engineering Firm' },
    { value: 'Consultant', text: 'Consultant' },
    { value: 'Contractor', text: 'Contractor' },
    { value: 'Academia', text: 'Academia' },
    { value: 'Other', text: 'Other' },
  ];

  experienceOptions = [
    { value: '', text: '-- Select One --' },
    { value: '0 to 5 years', text: '0 to 5 years' },
    { value: '5 to 10 years', text: '5 to 10 years' },
    { value: '10 to 15 years', text: '10 to 15 years' },
    { value: '15 to 20 years', text: '15 to 20 years' },
    { value: 'More than 20 years', text: 'More than 20 years' },
  ];

  // loginEmail = "";
  // loginPassword = "";
  // lastLoginFailed = false;
  // failureMessage = "";


  // get errors() {
  //   return userStore.httpErrors
  // }

  mounted() {
    userStore.clearErrors();
  }

  saveUser() {
    userStore.clearErrors();
    this.$v.$touch();
    if (!this.$v.$invalid) {
      if (this.tosAccepted) {
        this.newUser.password = this.password;
        this.newUser.tos_accepted = new Date(Date.now()).toISOString();
        userStore.createUser(this.newUser).then((response) => {
          if (response) { this.$router.push('/login'); }
        });
      } else {
        userStore.pushError({ name: 'TOS', message: 'Please accept the terms of service before signing up.' });
      }
    }
  }

  validations() {
    return {
      newUser: {
        first_name: {
          required,
        },
        last_name: {
          required,
        },
        email: {
          required,
          email,
        },
        state: {
          required,
        },
        country: {
          required,
        },
        primary_field: {
          required,
        },
        organization_type: {
          required,
        },
      },
      password: {
        required,
        minLength: minLength(6),
      },
      password2: {
        required,
        sameAs: sameAs('password'),
      },
      tosAccepted: {
        required,

      },
    };
  }

// submitLogin(): void {
//   console.log("Logging in");
//
//   userStore.login({email: this.loginEmail, password: this.loginPassword}).then(result => {
//
//     if (result) {
//       this.$root.$emit('bv::hide::modal', 'login-modal');
//       // this.$router.push("/projects");
//
//       if (userStore.userIsLoggedIn) {
//         projectStore.checkForLegacyReports(userStore.user);
//       }
//       projectStore.loadAvailableProjects();
//       this.$router.push('/projects')
//     }
//
//     // projectStore.loadAvailableReportsLegacy(userStore.user)
//   });
//   //
//   // axios.post('login', {
//   //   params: {email: this.loginEmail, password: this.loginPassword}
//   // }).then(response => {
//   //   console.log('login response', response);
//   //   store.commit('setToken', response.data.token);
//   //   store.commit('setUser', response.data.user);
//   //
//   //
//   // }).catch(reason => console.log("Failure", reason));
// }
}
